import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import OperationSettingsEdit from '../edit/index';
export default {
  name: 'OperationSettingsList',
  components: {
    OperationSettingsEdit: OperationSettingsEdit
  },
  data: function data() {
    return {
      citys: [],
      operationSettingsAreTypeEnums: [],
      isSelect: this.checkauthority('operation_settings_select'),
      isCreate: this.checkauthority('operation_settings_create'),
      isUpdate: this.checkauthority('operation_settings_update'),
      isDelete: this.checkauthority('operation_settings_delete'),
      selectForm: {
        areOneId: null,
        areTwoId: null,
        areThreeId: null,
        areType: '',
        createTime: null,
        createTimes: [],
        selectCitys: [],
        freeExperience: null,
        offlineActivities: null,
        firstChargeDiscount: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    tableAreName: function tableAreName(row) {
      return this.enums.checkEnumsValue(this.operationSettingsAreTypeEnums, row.areType, '');
    },
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.enums.getSettingsAreType(function (result) {
        thiz.operationSettingsAreTypeEnums = result.body;
      });
      this.initCitys();
    },
    dalete: function dalete(index, data) {
      var _this2 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.daleteApi(index, data);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                settingsId: data.settingsId
              };
              _context2.n = 1;
              return api.DELETE_OPERATIONSETTINGS(par);
            case 1:
              _this3.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.DELETE_BATCH_OPERATIONSETTINGS(par);
            case 1:
              _this4.$message.success('操作成功');
              _this4.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this5 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this5.tableSelects.forEach(function (element) {
          par.push(element.settingsId);
        });
        _this5.deleteBatchApi(par);
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.areOneId = null;
      this.selectForm.areTwoId = null;
      this.selectForm.areThreeId = null;
      this.selectForm.areType = '';
      this.selectForm.createTime = null;
      this.selectForm.createTimes = [];
      this.selectForm.selectCitys = [];
      this.selectForm.freeExperience = null;
      this.selectForm.offlineActivities = null;
      this.selectForm.firstChargeDiscount = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                pageNo: _this6.pageNo,
                pageSize: _this6.pageSize,
                areType: _this6.selectForm.areType,
                freeExperience: _this6.selectForm.freeExperience,
                offlineActivities: _this6.selectForm.offlineActivities,
                firstChargeDiscount: _this6.selectForm.firstChargeDiscount
              };
              if (_this6.selectForm.selectCitys.length > 1) {
                par.selectCitys = _this6.selectForm.selectCitys;
              }
              if (_this6.selectForm.createTimes.length >= 2) {
                par.startCreateTime = _this6.selectForm.createTimes[0];
                par.endCreateTime = _this6.selectForm.createTimes[1];
              }
              _context4.n = 1;
              return api.GET_OPERATIONSETTINGS_PAGE_LIST(par);
            case 1:
              res = _context4.v;
              _this6.tableData = res.body.datas;
              _this6.pageTotal = res.body.sumDataCount;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initEunmData();
    this.initTableData();
  }
};